var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.component, {
    tag: "component",
    attrs: { altText: "", src: _vm.image, showBackground: true },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }